import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useHasAnyAuthority } from '@/shared/auth/use-has-any-authority';
import { APP_FEATURE_GUARDS } from '@/shared/constants/app-permissions';
import { useQstatPhoneUsersTopicSubscription } from '@/shared/hooks/useQstatPhoneUsersTopicSubscription';
import { applyPhoneUsersWsEvent } from '@/shared/reducers/realtime.reducer';
import { useAppDispatch } from '@/store';
/**
 * Keeps `/topic/qstat.phone-users` subscribed while the user has realtime access
 * (layout-level so events are not missed during REST load / page transitions).
 */
export function RealtimePhoneUsersWsProvider({ children }) {
    const dispatch = useAppDispatch();
    const canAccessRealtime = useHasAnyAuthority(APP_FEATURE_GUARDS.realtimeAccess);
    const onPhoneUsersEvent = useCallback((event) => {
        dispatch(applyPhoneUsersWsEvent(event));
    }, [dispatch]);
    useQstatPhoneUsersTopicSubscription({
        enabled: canAccessRealtime,
        onEvent: onPhoneUsersEvent,
    });
    return _jsx(_Fragment, { children: children });
}
